export default __webpack_public_path__ + "i18n/uk.c7802cb0914129f0e216fa13847c8e39.json";